import { API, authClient } from "../index";

export const getPerfumes = () => {
  return authClient().get(`${API}/perfume`);
};
